import { PpwrPackagingInfoDto } from '../data-transfer/entities/ppwr-entities/ppwr-packaging-info-dto';
import { DeadlineStateDisplay, getEffectiveDeadlineDisplay, getDeadlineOutcomeDisplay } from './row-badge-map';

export type PpwrPackagingInfoRow = PpwrPackagingInfoDto & DeadlineStateDisplay & { submission: DeadlineStateDisplay; closing: DeadlineStateDisplay };

export function applyPpwrRowState(row: PpwrPackagingInfoDto): PpwrPackagingInfoRow {
  return Object.assign(row, {
    ...getEffectiveDeadlineDisplay(row.dataExchangeRequestStatus, row.dataExchangeRequestDeadlineState, row.dataExchangeRequestClosingState),
    submission: getDeadlineOutcomeDisplay(row.dataExchangeRequestSubmissionState, 'submissionState'),
    closing: getDeadlineOutcomeDisplay(row.dataExchangeRequestClosingState, 'closingState'),
  });
}
